import { render } from "./DuedateCell.vue?vue&type=template&id=532ea839"
import script from "./DuedateCell.vue?vue&type=script&lang=js"
export * from "./DuedateCell.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__